'use client'
import React from 'react'
import Script from 'next/script'
import Logo from '../../public/logo.webp'

const WebCallWidget = () => {
	return (
		<Script
			src='https://webcallcdn.z29.web.core.windows.net/web-call-widget.umd.cjs'
			onLoad={(e) => {
				window.WebCallWidget.init({
					assistant: 'Metalbook AI Assistant',
					theme: 'light', //light, dark
					token: process.env.widgetToken, //Provided seperately
					logo: { Logo },
					width: '300px',
					height: '600px',
					widgetStyle: 'collapsed', //collapsed, collapsed-small, open
					primaryColor: '#EA3162',
					secondaryColor: '#F69F02',
					firstMessage: 'Hello! How can I assist you today?',
					primaryMode: 'voice', // chat, voice
					disclaimer:
						'This responses provided by this assistant are generated by AI and are for informational purposes only. Please verify critical information through official channels.',
				})
			}}
		/>
	)
}

export default WebCallWidget
